import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateLevel as apiUpdate } from "../../api/apiLevels";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useUpdateLevel() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: editLevel, isPending: isUpdate, data: results, error } = useMutation({
        mutationFn: ({ req, id }) => apiUpdate(req, id),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["levels"] });
            navigate('/levels');
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { editLevel, isUpdate, error, results };
}
